(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-grid-with-captions"] && !Shopify.designMode) return;
  try {
    
/* Not required */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-design"] && !Shopify.designMode) return;
  try {
    
/* Not required */

  } catch(e) { console.error(e); }
})();
})();
